import { useEffect, useState } from "react";
import { addData } from "../Servicescalls";

const Header = () => {
  const [d, setd] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // get all
  const getAllSections = async () => {
    setLoading(true);
    const response = await addData("getallmodules");
    var _data = response;
    setd(_data.data.contactus[0]);
    setLoading(false);
  };

  useEffect(() => {
    const header = document.querySelector(".header-sticky");

    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 350) {
        header?.classList.add("sticky-show");
      } else {
        header?.classList.remove("sticky-show");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    getAllSections(); // this is my API CALLINGs
    const handleScroll = () => {
      const isMobile = window.innerWidth <= 768;

      if (isMobile && window.scrollY > 200) {
        document.getElementById("header")?.classList.add("scrolled");
        document
          .querySelector(".mobile-header.mobile-header1")
          ?.classList.add("scrolled");
      } else if (!isMobile && window.scrollY > 400) {
        document.getElementById("header")?.classList.add("scrolled");
        document
          .querySelector(".mobile-header.mobile-header1")
          ?.classList.add("scrolled");
      } else {
        document.getElementById("header")?.classList.remove("scrolled");
        document
          .querySelector(".mobile-header.mobile-header1")
          ?.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {loading && (
        <div className="preloader">
          <div className="loading-container">
            <div className="loading" />
            <div id="loading-icon">
              <img src="assets/img/logo/logo1.png" alt="myLogoo" />
            </div>
          </div>
        </div>
      )}

      {/* <a
        href={`https://wa.me/9515462333?text=Hi`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-icon"
      >
        <i className="fa fa-whatsapp fa-2x" aria-hidden="true"></i>
      </a> */}

      <a
        href="#"
        onclick="scrollToTop(); return false;"
        id="scrollTopBtn"
        class="scroll-top-icon"
      >
        <i class="fa-solid fa-arrow-up fa-1x text-white" aria-hidden="true"></i>
      </a>

      <div className="body-overlay" />

      <header className="main-header">
        <div className="header-sticky">
          <nav className="container">
            <div className="navbar navbar-expand-lg p-0">
              {/* Logo Start */}
              <a
                className="navbar-brand"
                href="https://www.rfirms.com/"
                target="_blank"
              >
                <img src="assets/img/logo/logo1.png" alt="Logo" />
              </a>
              {/* Logo End */}

              {/* Main Menu Start */}
              <div className="collapse navbar-collapse main-menu">
                <div className="nav-menu-wrapper">
                  <ul className="navbar-nav mr-auto" id="menu">
                    <li className="nav-item">
                      <a className="nav-link" href="#">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#aboutSection">
                        About Us
                      </a>
                    </li>

                    <li className="nav-item">
                      <a className="nav-link" href="#partnerss">
                        Partners
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#price">
                        Plans
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#contactSection">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>

                {/* Header Button */}
                <div className="header-btn d-inline-flex">
                  <a href={`tel:${d.phone}`} className="btn-default1">
                    <i className="fa fa-phone mx-1" /> +91{" "}
                    {d.phone
                      ?.replace(/\D/g, "")
                      .slice(-10)
                      .replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3")}
                  </a>
                </div>
              </div>

              {/* Mobile Call Icon */}
              <div>
                <a
                  href={`tel:${d.phone}`}
                  className="d-block d-lg-none"
                  style={{
                    backgroundColor: "#fdb631",
                    height: 50,
                    width: 50,
                    borderRadius: "50%",
                    padding: 10,
                  }}
                >
                  <i className="fa fa-phone mx-2 my-2" />
                </a>
              </div>
            </div>
          </nav>
          <div className="responsive-menu" />
        </div>
      </header>

      <div className="social-container">
        <div className="socials">
          <a
            href={`https://wa.me/9515462333?text=Hi`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp"
          >
            <i className="fab fa-whatsapp"></i>
            <span className="label">WhatsApp</span>
          </a>
          <a
            href={d.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="instagram"
          >
            <i className="fab fa-instagram"></i>
            <span className="label">Instagram</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
